import AppTitle from '@theme/components/atom/AppTitle'
import LoginForm from '@theme/components/user/LoginForm'

export default {
  components: {
    AppTitle,
    LoginForm,
  },
}
